import React, { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { useDispatch, useSelector } from 'react-redux';

import CommonModal from '../../../components/common-modal/CommonModal';
import DetailsTab from './DetailsTab';
import EditsTab from './EditsTab';
import { resetMessageLogs } from '../../../redux/scout/scoutReducer';
import CommonLoader from '../../../components/common-loader/CommonLoader';
import { resetId8MessageLogs } from '../../../redux/id8/id8Reducer';

import scss from './MessageInfoModal.module.scss';

const MessageInfoModal = ({ isOpen, onClose, message, getMessageLogs, selector, onOpenImages }) => {
  const { t } = useTranslation('scout');
  const dispatch = useDispatch();

  const isLoading = useSelector(selector).isMessageLogsLoading;

  useEffect(() => {
    if (isOpen && getMessageLogs) {
      dispatch(getMessageLogs({ messageId: message.id }));
    }
  }, [isOpen, message, dispatch]);

  useEffect(() => {
    if (!isOpen) {
      dispatch(resetMessageLogs());
      dispatch(resetId8MessageLogs());
    }
  }, [isOpen, dispatch]);

  return (
    <CommonModal isOpen={isOpen} onClose={onClose}>
      <div className={scss.wrapper}>
        <h3 className={scss.title}>{t('messageInformation')}</h3>

        <CommonLoader isLoading={isLoading} />

        <Tabs className={scss.tabs}>
          <TabList className={scss.tabList}>
            <Tab>{t('details')}</Tab>
            <Tab>{t('edits')}</Tab>
          </TabList>

          <TabPanel>
            <DetailsTab selector={selector} onOpenImages={onOpenImages} />
          </TabPanel>

          <TabPanel>
            <EditsTab selector={selector} />
          </TabPanel>
        </Tabs>
      </div>
    </CommonModal>
  );
};

export default memo(MessageInfoModal);
